var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAboutSectionStepImageBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172.494,
    height: "47.43mm",
    viewBox: "0 0 45.639 47.43",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.4,
    result: "flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "flood",
    in2: "SourceGraphic",
    operator: "in",
    result: "composite1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "composite1",
    result: "blur",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feOffset", {
    result: "offset"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "offset",
    result: "fbSourceGraphic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.4,
    result: "flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "flood",
    in2: "fbSourceGraphic",
    operator: "in",
    result: "composite1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "composite1",
    result: "blur",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feOffset", {
    result: "offset"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "offset",
    result: "composite2"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-30 -98.603 160.29)",
    fill: "#fff",
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m88.014 110.33-13.175 7.607-13.175-7.607V95.117l13.175-7.607 13.175 7.607z",
    style: {
      paintOrder: "markers fill stroke"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m88.014 110.33-13.175 7.607-13.175-7.607V95.117l13.175-7.607 13.175 7.607z",
    style: {
      paintOrder: "markers fill stroke"
    },
    transform: "scale(.9467) rotate(-30 -95.468 158.558)",
    fill: "#404040"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutSectionStepImageBackground);
export default __webpack_public_path__ + "static/media/about_section_step_image_background.c4b8957f2236364699c1c2290f0a4ced.svg";
export { ForwardRef as ReactComponent };